export { DetailLink } from './DetailLink';
